module.exports = __webpack_public_path__ + "static/img/zwfwIcon.511f6262.png";